import tealiumWrapper from './tealiumWrapper';
import { TEALIUM_SCHEMA_MODAL_OPEN } from './trackingConstants';
import { GLOBAL_TRACKING_KEY } from './constants';

export type ClickThroughSource = {
  element?: string;
  page?: string;
  type?: string;
};

export const setTrackingSource = (params: ClickThroughSource): void => {
  const { element, page, type } = params;
  localStorage.setItem(
    GLOBAL_TRACKING_KEY,
    JSON.stringify({ element, page, type }),
  );
};

export const trackSignInModalClick = (): void => {
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_MODAL_OPEN,
    data: {
      event_name: 'my_rea_modal_open',
      intent: 'sign_in',
    },
  }));
};

export const trackJoinModalClick = (): void => {
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_MODAL_OPEN,
    data: {
      event_name: 'my_rea_modal_open',
      intent: 'join',
    },
  }));
};
